
// api.js
import { ORCHESTATION_URL } from "../../configuration/genovAiConfig";

const getToken = () => {
    return sessionStorage.getItem('__authVortexOrquestator'); 
};

// Función interceptor para realizar peticiones con token
const fetchWithToken = async (url: string, options: any = {}, addHeader: boolean = true) => {

    const token = getToken();

    // Add token to request
    const headers = {
        ...options.headers,
        ...(token ? { 'Authorization': `Bearer ${token}` } : {}),
        "X-Orchestator-Header": "Vortex-Chat" // Custom header
    };

    if ( addHeader) headers['Content-Type'] = 'application/json';

    const response = await fetch(`${ORCHESTATION_URL}${url}`, {
        ...options,
        headers,
        //credentials: 'include', // Para que se envíen las cookies de sesión
    });

    // Manejo de errores (opcional)
    if (!response.ok) {
        let errorMessage = `Error HTTP: ${response.status}`;

        try {
            const errorData = await response.json();
            if (errorData && errorData.message) {
                errorMessage = errorData.message;
            }
        } catch (e) {
            // si falla el parseo, mantén el mensaje predeterminado
        }
    
        const error = new Error(errorMessage);
        (error as any).status = response.status;  // importante para capturar en React
        throw error;
    }

    return response;
};

// Exportar la función para usarla en otros componentes
export { fetchWithToken };